import {BOOKS_FETCHED} from "../types";

export default function booksCUD(state = {}, action = {}) {
    switch (action.type) {
        case BOOKS_FETCHED:
            return action.data;
        default:
            return state
    }
}